// Pergunta do navegador antes de recarregar/fechar a aba enquanto o vendedor
// está em ligação ou disponível na fila.
//
// POR QUE `beforeunload` mesmo com o `pagehide` do softphone: os dois resolvem
// problemas opostos. O `pagehide` (sip/use-terminate-on-unload) é a limpeza —
// encerra a chamada quando a página JÁ vai embora, e por isso precisa ser o
// evento que o navegador nunca pula. O `beforeunload` é a PERGUNTA, e é o único
// que a faz. Se a pessoa confirmar, a limpeza acontece igual.
//
// O texto do diálogo é do navegador: mensagem customizada é ignorada desde 2017
// (Chrome 51 / Firefox 44). Por isso não há string nossa aqui — só o
// `preventDefault` + `returnValue`, que é o que ainda liga o diálogo.
import { useEffect } from "react";
import { useSyncExternalStore } from "react";
import { getCallPresence, shouldGuardUnload, subscribeCallPresence } from "./call-presence.js";

export function useCallPresence() {
  return useSyncExternalStore(subscribeCallPresence, getCallPresence, getCallPresence);
}

export function UnloadGuard() {
  const presence = useCallPresence();
  const segurar = shouldGuardUnload(presence);

  useEffect(() => {
    if (!segurar) return;
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Navegadores antigos só abrem o diálogo com `returnValue` preenchido; o
      // conteúdo da string é ignorado por todos eles.
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [segurar]);

  return null;
}
